import { INSTORE_CURATED_OFFERS_HEADING_FILL } from './types';

export const fillInstoreCuratedOffersHeading = payload => ({
  type: INSTORE_CURATED_OFFERS_HEADING_FILL,
  payload,
});
